import { Box, List, Keyword } from "@siteimprove/alfa-css";
import { Longhand } from "../longhand.js";
/**
 * @remarks
 * This is needed in the shorthand background
 *
 * @internal
 */
export const parse = Box.parse;
/**
 * @remarks
 * This is needed in the shorthand background
 *
 * @internal
 */
export const initialItem = Keyword.of("padding-box");
/**
 * {@link https://developer.mozilla.org/en-US/docs/Web/CSS/background-origin}
 * @internal
 */
export default Longhand.of(List.of([initialItem], ", "), List.parseCommaSeparated(parse), (value) => value);
//# sourceMappingURL=background-origin.js.map